class CartDrawer extends HTMLElement {
  constructor() {
    super();

    this.addEventListener(
      "keyup",
      (evt) => evt.code === "Escape" && this.close()
    );
    this.querySelector("#CartDrawer-Overlay").addEventListener(
      "click",
      this.close.bind(this)
    );
    this.setHeaderCartIconAccessibility();
  }

  setHeaderCartIconAccessibility() {
    const cartLink = document.querySelector("#cart-icon-bubble");
    if (!cartLink) return;

    cartLink.setAttribute("role", "button");
    cartLink.setAttribute("aria-haspopup", "dialog");
    cartLink.addEventListener("click", (event) => {
      event.preventDefault();
      this.open(cartLink);
    });
    cartLink.addEventListener("keydown", (event) => {
      if (event.code.toUpperCase() === "SPACE") {
        event.preventDefault();
        this.open(cartLink);
      }
    });
  }

  open(triggeredBy) {
    if (triggeredBy) this.setActiveElement(triggeredBy);
    const cartDrawerNote = this.querySelector('[id^="Details-"] summary');
    if (cartDrawerNote && !cartDrawerNote.hasAttribute("role"))
      this.setSummaryAccessibility(cartDrawerNote);
    // here the animation doesn't seem to always get triggered. A timeout seem to help
    setTimeout(() => {
      this.classList.add("animate", "active");
      const cartDrawerItems = this.querySelector("cart-drawer-items");
      if (cartDrawerItems) {
        cartDrawerItems.updateCartUpsellToggleState();
        cartDrawerItems.updateCartUpsellVisibility();
      }
      // Dispatch cart:open event
      document.dispatchEvent(new CustomEvent('cart:open'));
    });

    this.addEventListener(
      "transitionend",
      () => {
        const containerToTrapFocusOn = this.classList.contains("is-empty")
          ? this.querySelector(".drawer__inner-empty")
          : document.getElementById("CartDrawer");
        const focusElement =
          this.querySelector(".drawer__inner") ||
          this.querySelector(".drawer__close");
        trapFocus(containerToTrapFocusOn, focusElement);
      },
      { once: true }
    );

    document.body.classList.add("overflow-hidden");
  }

  close() {
    this.classList.remove("active");
    removeTrapFocus(this.activeElement);
    document.body.classList.remove("overflow-hidden");
  }

  setSummaryAccessibility(cartDrawerNote) {
    cartDrawerNote.setAttribute("role", "button");
    cartDrawerNote.setAttribute("aria-expanded", "false");

    if (cartDrawerNote.nextElementSibling.getAttribute("id")) {
      cartDrawerNote.setAttribute(
        "aria-controls",
        cartDrawerNote.nextElementSibling.id
      );
    }

    cartDrawerNote.addEventListener("click", (event) => {
      event.currentTarget.setAttribute(
        "aria-expanded",
        !event.currentTarget.closest("details").hasAttribute("open")
      );
    });

    cartDrawerNote.parentElement.addEventListener("keyup", onKeyUpEscape);
  }

  renderContents(parsedState) {
    this.querySelector(".drawer__inner").classList.contains("is-empty") &&
      this.querySelector(".drawer__inner").classList.remove("is-empty");
    this.productId = parsedState.id;
    this.getSectionsToRender().forEach((section) => {
      const sectionElement = section.selector
        ? document.querySelector(section.selector)
        : document.getElementById(section.id);

      if (!sectionElement) return;
      sectionElement.innerHTML = this.getSectionInnerHTML(
        parsedState.sections[section.id],
        section.selector
      );
    });

    var __epRows = this.querySelectorAll(".cart-item").length;
    this.classList.toggle("is-empty", __epRows === 0); /* __epochSyncEmpty */

    setTimeout(() => {
      this.querySelector("#CartDrawer-Overlay").addEventListener(
        "click",
        this.close.bind(this)
      );
      this.open();
      try { if (window.Shopify && Shopify.PaymentButton && typeof Shopify.PaymentButton.init === "function") { Shopify.PaymentButton.init(); } } catch (e) {}
    });
  }

  getSectionInnerHTML(html, selector = ".shopify-section") {
    return new DOMParser()
      .parseFromString(html, "text/html")
      .querySelector(selector).innerHTML;
  }

  getSectionsToRender() {
    return [
      {
        id: "cart-drawer",
        selector: "#CartDrawer",
      },
      {
        id: "cart-icon-bubble",
      },
    ];
  }

  getSectionDOM(html, selector = ".shopify-section") {
    return new DOMParser()
      .parseFromString(html, "text/html")
      .querySelector(selector);
  }

  setActiveElement(element) {
    this.activeElement = element;
  }
}

customElements.define("cart-drawer", CartDrawer);

class CartDrawerItems extends CartItems {
  getSectionsToRender() {
    return [
      {
        id: "CartDrawer",
        section: "cart-drawer",
        selector: ".drawer__inner",
      },
      {
        id: "cart-icon-bubble",
        section: "cart-icon-bubble",
        selector: ".shopify-section",
      },
    ];
  }
}

customElements.define("cart-drawer-items", CartDrawerItems);


/* ---- EPOCH cart-drawer order bump ---- */
(function () {
  var SEC = "epoch-cart-bump";
  var cacheHTML = null, cachePid = null;
  function dismissed() { try { return sessionStorage.getItem("epoch_bump_added") === "1"; } catch (e) { return false; } }
  function previewParam() {
    try {
      if (window.Shopify && Shopify.theme && Shopify.theme.role && Shopify.theme.role !== "main") {
        return "&preview_theme_id=" + Shopify.theme.id;
      }
    } catch (e) {}
    return "";
  }
  async function fetchCard(pid, intent) {
    try {
      var url = "/recommendations/products?section_id=" + SEC + "&product_id=" + pid + "&intent=" + intent + "&limit=10" + previewParam();
      var res = await fetch(url);
      if (!res.ok) return null;
      var html = await res.text();
      return new DOMParser().parseFromString(html, "text/html").querySelector("#epoch-bump-card");
    } catch (e) { return null; }
  }
  function vidOf(node) { var b = node && node.querySelector(".epoch-bump__add"); return b ? b.getAttribute("data-vid") : null; }
  async function loadBump() {
    return; /* bump rendered server-side inline in cart-drawer.liquid */
    var slot = document.getElementById("epoch-bump");
    if (!slot) return;
    if (dismissed()) { slot.innerHTML = ""; slot.removeAttribute("data-loaded"); return; }
    var pid = slot.getAttribute("data-pid");
    if (!pid) { slot.innerHTML = ""; slot.removeAttribute("data-loaded"); return; }
    if (slot.getAttribute("data-loaded") === pid && slot.querySelector("#epoch-bump-card")) return;
    // INSTANT re-paint from cache (same product context) -> no flicker on re-render
    if (cachePid === pid && cacheHTML) { slot.innerHTML = cacheHTML; slot.setAttribute("data-loaded", pid); }
    // revalidate (covers product-set changes on remove)
    var card = await fetchCard(pid, "complementary");
    if (!card) card = await fetchCard(pid, "related");
    var s = document.getElementById("epoch-bump");
    if (!s || dismissed() || s.getAttribute("data-pid") !== pid) return;
    if (card) {
      cacheHTML = card.outerHTML; cachePid = pid;
      if (vidOf(s) !== vidOf(card)) { s.innerHTML = cacheHTML; s.setAttribute("data-loaded", pid); } // swap only if rec changed
      else { s.setAttribute("data-loaded", pid); }
    } else if (cachePid !== pid) {
      s.innerHTML = ""; s.removeAttribute("data-loaded");
    }
  }
  var debTimer = null;
  function debouncedLoad() { clearTimeout(debTimer); debTimer = setTimeout(loadBump, 60); }
  function observeDrawer() {
    var drawer = document.querySelector("cart-drawer");
    if (!drawer || drawer.__epochBumpObserved) return;
    drawer.__epochBumpObserved = true;
    new MutationObserver(function (muts) {
      for (var i = 0; i < muts.length; i++) {
        var t = muts[i].target;
        if (t && t.closest && t.closest("#epoch-bump")) continue; // ignore our own injection -> no loop
        debouncedLoad();
        return;
      }
    }).observe(drawer, { childList: true, subtree: true });
  }
  document.addEventListener("cart:open", loadBump);
  document.addEventListener("DOMContentLoaded", function () { loadBump(); observeDrawer(); });
  observeDrawer();
  document.addEventListener("click", async function (e) {
    var btn = e.target.closest && e.target.closest(".epoch-bump__add");
    if (!btn) return;
    e.preventDefault();
    if (btn.classList.contains("is-added") || btn.classList.contains("is-loading")) return;
    var vid = btn.getAttribute("data-vid");
    if (!vid) return;
    var txt = btn.querySelector(".epoch-bump__add-txt");
    btn.classList.add("is-added", "is-justadded");
    if (txt) txt.innerHTML = '<svg class="epoch-bump__check" viewBox="0 0 24 24" width="13" height="13" fill="none" stroke="currentColor" stroke-width="3" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><path d="M5 13l4 4L19 7"/></svg>';
    btn.setAttribute("aria-label", "Added to cart");
    try {
      var res = await fetch("/cart/add.js", {
        method: "POST",
        headers: { "Content-Type": "application/json", "Accept": "application/json" },
        body: JSON.stringify({ items: [{ id: Number(vid), quantity: 1 }], sections: ["cart-drawer", "cart-icon-bubble"], sections_url: "/" })
      });
      var state = await res.json();
      setTimeout(function () {
        var cd = document.querySelector("cart-drawer");
        if (cd && state.sections) { cd.classList.remove("is-empty"); cd.renderContents(state); }
      }, 480);
    } catch (err) {
      btn.classList.remove("is-added", "is-justadded");
      if (txt) txt.textContent = "+";
      btn.setAttribute("aria-label", "Add to cart");
    }
  });
})();
